<section id="latest-issue" class="w-full h-fit flex justify-center my-10">
    <a [routerLink]="['issue/', latestIssue()?.id]" class="w-11/12 h-full rounded-md">
        <p class="pl-3 text-xl md:text-2xl font-bold text-primary-dark-2 border-l-4 md:border-l-8 rounded-md border-secondary">
            Latest Issue
        </p>

        <div class="w-full h-full flex flex-col lg:flex-row justify-start mt-5 rounded-md shadow-md overflow-hidden">
            @if(isLoading){
                <app-section-loader />
            }@else {
                <!-- Image Section -->
            <div class="relative group w-full lg:w-1/3 p-4 bg-gradient-to-r from-primary-dark-2/10 to-blue-100/0">
                <img 
                    [src]="latestIssue()?.coverImageUrl" 
                    [alt]="latestIssue()?.title" 
                    class="w-full h-56 object-cover rounded-md transform group-hover:scale-105 transition-transform duration-300 ease-in-out shadow-sm">
            </div>

            <!-- Text Section -->
            <div class="w-full lg:w-2/3 h-full py-6 px-4 lg:py-8 lg:px-6 grid gap-y-4">
                <!-- Metadata -->
                <div>
                    <p class="text-xs md:text-sm text-secondary">
                        The Byte Magazine
                        <span class="text-primary-dark-2 mx-1">|</span>
                        {{latestIssue()?.number | ordinal}} Issue
                    </p>
                    <p class="text-2xl md:text-4xl text-primary-dark font-extrabold mt-3">
                        {{latestIssue()?.title}}
                    </p>
                </div>

                <!-- Description -->
                <p class="text-sm md:text-base text-gray-400 mt-3">
                    {{latestIssue()?.description}}
                </p>

                <!-- Action Link -->
                <div class="mt-5">
                    <a 
                        [routerLink]="['issue/', latestIssue()?.id]"
                        class="inline-flex items-center text-sm text-primary-dark font-medium transition ease-in-out duration-300 hover:text-secondary">
                        Read it now
                        <i class="arrow bi bi-arrow-right ml-2"></i>
                    </a>
                </div>
            </div>
            }
        </div>
    </a>
</section>
